import { Component, OnInit } from '@angular/core'
import { Store } from '@ngxs/store'
import { WorkoutState } from 'app/state/workout/workout.state'
import moment from 'moment'
import * as _ from 'lodash'
import { BehaviorSubject, Observable } from 'rxjs'
import { EditSetDialogComponent } from '../edit-set-dialog/edit-set-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { EditSet, SaveWorkout, AddUnsyncedWorkoutSession, SaveComments, SetActiveDay, SetCircuitRounds } from 'app/state'
import { Router, ActivatedRoute } from '@angular/router'
import { DocumentService } from 'app/services/document.service'
import { DataService } from 'app/services/data.service'
import { PageTransitionService, PAGETRANSITIONS } from 'app/services/page-transition.service'
import { EditCircuitDialogComponent } from '../edit-circuit-dialog/edit-circuit-dialog.component'
import { NotesDialogComponent } from '../notes-dialog/notes-dialog.component'
import { PlanDocument } from '../../../shared/document-sync'

@Component({
  standalone: false,
  selector: 'app-exercise-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss']
})
export class CompleteComponent implements OnInit {
  workoutSession: any
  workoutSessionSubject: BehaviorSubject<any>
  workoutSession$: Observable<any>
  timeElapsed: string
  timeMinutes: number
  timeSeconds: number
  isHistory: boolean
  rpeScore = 0
  hasRM = {
    oneRM: {},
    index: 0
  }
  repStrings = [
    'Rest',
    'Very, Very Easy',
    'Easy',
    'Moderate',
    'Somewhat Hard',
    'Hard',
    'Hard',
    'Very Hard',
    'Very Hard',
    'Very Hard',
    'Maximal'
  ]
  allowExecute: boolean;

  constructor(
    private store: Store,
    private router: Router,
    private dataService: DataService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private pageTransitionService: PageTransitionService,
    private documentService: DocumentService,
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(async (params) => {
      const workoutSessionId = params.workoutSessionId
      if (!workoutSessionId) {
        this.isHistory = false
        this.workoutSession = _.cloneDeep(this.store.selectSnapshot(WorkoutState.currentWorkoutSession))
        if (!this.workoutSessionSubject || !this.workoutSession$) {
          this.workoutSessionSubject = new BehaviorSubject<any>(this.workoutSession);
          this.workoutSession$ = this.workoutSessionSubject.asObservable();
        } else {
          this.workoutSessionSubject.next(this.workoutSession);          
        }
        this.setTimeElapsed()
      } else {
        this.isHistory = true


        await this.dataService.getWorkoutSessionDocument(workoutSessionId).then((workoutSession) => {
          this.workoutSession = workoutSession
          if (!this.workoutSessionSubject || !this.workoutSession$) {
            this.workoutSessionSubject = new BehaviorSubject<any>(this.workoutSession);
            this.workoutSession$ = this.workoutSessionSubject.asObservable();
          } else {
            this.workoutSessionSubject.next(this.workoutSession);          
          }
          this.rpeScore = this.workoutSession.rpe
          this.setTimeElapsed()
        })


        const planDocument: PlanDocument|undefined = this.documentService.store.planDocuments.find((planDoc) => {
          return planDoc.document.id === this.workoutSession.plan.id
        })

        if (!planDocument) {
          this.allowExecute = false;
        } {
          this.allowExecute = true;
          const workoutDocument = _.find((planDocument as PlanDocument).document.workouts, { id: this.workoutSession.workout.id });
          if (!workoutDocument) {
            this.allowExecute = false;
          }
        }
      }
    })
  }

  setTimeElapsed() {
    const seconds = moment.duration(this.workoutSession.completion_time_ms).seconds().toString().padStart(2, '0')
    const minutes = _.floor(this.workoutSession.completion_time_ms / 1000 / 60)
    // console.log('got moment', seconds, minutes, this.workoutSession.completion_time_ms)
    this.timeElapsed = `${minutes}:${seconds}`
    // Convert to numbers
    this.timeMinutes = +minutes
    this.timeSeconds = +seconds
  }

  openEditTier(tierIndex) {
    this.dialog.open(EditCircuitDialogComponent, {
      data: {
        tierIndex
      }
    }).afterClosed().subscribe(result => {
      if (result && result.success) {
        const rounds = result.num_rounds
        if (this.workoutSession.workout.tiers[tierIndex].circuit) {
          this.workoutSession.workout.tiers[tierIndex].circuit.executions[0].num_rounds = rounds
        } else {
          this.workoutSession.workout.tiers[tierIndex].executions[0].num_rounds = rounds
        }
        // trigger the UI update by updating the observable, too
        this.workoutSessionSubject.next(this.workoutSession);
        this.store.dispatch(new SetCircuitRounds(rounds, tierIndex))
      }
    })
  }

  openEditCircuitDialog(tierIndex, rowIndex) {
    const dialogRef = this.dialog.open(EditSetDialogComponent, {
      maxWidth: '100vw',
      width: '80%',
      data: {
        tierIndex,
        rowIndex,
        setIndex: -1,
        forComplete: true
      }
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res && res.success) {
        console.log(res);
        const execution = _.cloneDeep(this.workoutSession.workout.tiers[tierIndex].rows[rowIndex].executions[0])
        const complete_time = execution.complete_time
        if (res.isComplete && !complete_time) {
          execution.complete_time = moment().format()
        } else if (!res.isComplete && complete_time) {
          execution.complete_time = undefined
        }
        execution.parameter_values = res.setParamValues
        this.workoutSession.workout.tiers[tierIndex].rows[rowIndex].executions[0] = execution
        // trigger UI update when changed
        this.workoutSessionSubject.next(this.workoutSession);
        this.store.dispatch(new EditSet(
          tierIndex,
          rowIndex,
          0,
          res.setParamValues,
          execution.complete_time
        ))
      }
    })
  }

  openCommentsDialog(tierIndex: number, rowIndex: number) {
    const dialogRef = this.dialog.open(NotesDialogComponent, {
      maxWidth: '100vw',
      width: '80%',
      data: {
        isTierNote: false,
        tierIndex,
        rowIndex,
        workoutSession: this.workoutSession,
        isHistory: this.isHistory,
        isCircuit: rowIndex === -1
      }
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res && res.success) {
        this.store.dispatch(new SaveComments(res.notes, tierIndex, rowIndex)).subscribe(() => {
          this.workoutSession = _.cloneDeep(this.store.selectSnapshot(WorkoutState.currentWorkoutSession))
          this.snackBar.open('Saved notes.', undefined, {
            duration: 2500
          })
        })
      }
    })
  }

  openEditSet(tierIndex: number, rowIndex: number, setIndex: number) {
    const dialogRef = this.dialog.open(EditSetDialogComponent, {
      maxWidth: '100vw',
      width: '80%',
      data: {
        tierIndex,
        rowIndex,
        setIndex,
        forComplete: true
      }
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res && res.success) {
        const execution = _.cloneDeep(this.workoutSession.workout.tiers[tierIndex].rows[rowIndex].executions[setIndex])
        const complete_time = execution.complete_time
        if (res.isComplete && !complete_time) {
          execution.complete_time = moment().format()
        } else if (!res.isComplete && complete_time) {
          execution.complete_time = undefined
        }
        execution.parameter_values = res.setParamValues
        this.workoutSession.workout.tiers[tierIndex].rows[rowIndex].executions[setIndex] = execution
        // trigger UI update
        this.workoutSessionSubject.next(this.workoutSession);
        this.store.dispatch(new EditSet(
          tierIndex,
          rowIndex,
          setIndex,
          res.setParamValues,
          execution.complete_time
        ))
      }
    })
  }

  saveWorkout() {
    const totalTime = (this.timeMinutes * 60000) + (this.timeSeconds * 1000)
    this.store.dispatch([
      new SaveWorkout(this.rpeScore, totalTime),
      new AddUnsyncedWorkoutSession(this.workoutSession.id)]
    ).subscribe(() => {
      this.snackBar.open('Workout saved.', undefined, {
        duration: 2500
      })
      this.pageTransitionService.setCurrentAnimation(PAGETRANSITIONS.RIGHT)
      this.router.navigate(['/main'])
    })
  }

  closeHistory() {
    this.pageTransitionService.setCurrentAnimation(PAGETRANSITIONS.RIGHT)
    this.router.navigate(['/main'])
  }

  onSliderChange($event: number) {
    this.rpeScore = $event;
  }

  onTimeChange($event, type: string) {
    const value = $event.target.value
    if (!value) {
      return
    }
    switch (type) {
      case 'minutes':
        this.timeMinutes = value
        break;
      case 'seconds':
        this.timeSeconds = value
        break;
    }
    this.timeElapsed = `${this.timeMinutes}:${this.timeSeconds}`
  }

  async startNewWorkout() {
    const activeGroup = this.workoutSession.group
    activeGroup.key = this.workoutSession.group.id
    const activePlan = this.workoutSession.plan
    activePlan.key = this.workoutSession.plan.id
    const activeDay = this.workoutSession.workout
    activeDay.key = this.workoutSession.workout.id
    activeDay.planUUID = this.workoutSession.plan.id
    this.store.dispatch(new SetActiveDay(
      activeGroup,
      activePlan,
      activeDay)
    ).subscribe(() => {
      this.pageTransitionService.setCurrentAnimation(PAGETRANSITIONS.LEFT)
      this.router.navigate(['playcard-summary'])
    })
  }
}
